// extracted by mini-css-extract-plugin
export var heroHeaderLeft = "m_pY d_gt d_cr";
export var heroHeaderCenter = "m_gv d_gv d_cr d_dv";
export var heroHeaderRight = "m_gw d_gw d_cr d_dw";
export var heroParagraphLeft = "m_pZ d_gq d_cv";
export var heroParagraphCenter = "m_gr d_gr d_cv d_dv";
export var heroParagraphRight = "m_gs d_gs d_cv d_dw";
export var heroBtnWrapperLeft = "m_p0 d_d1 d_d0 d_v d_by d_bF";
export var heroBtnWrapperCenter = "m_p1 d_d2 d_d0 d_v d_by d_bC";
export var heroBtnWrapperRight = "m_p2 d_d3 d_d0 d_v d_by d_bG";
export var overlayBtnWrapper = "m_p3 d_gp d_Z d_6 d_7 d_8 d_bm d_cb";
export var design4 = "m_p4 d_gn d_Z d_6 d_7 d_bm";
export var heroExceptionSmall = "m_p5 q_p5";
export var heroExceptionNormal = "m_p6 q_p6";
export var heroExceptionLarge = "m_p7 q_p7";
export var Title1Small = "m_p8 q_p8 q_qN q_qP";
export var Title1Normal = "m_p9 q_p9 q_qN q_qQ";
export var Title1Large = "m_qb q_qb q_qN q_qR";
export var BodySmall = "m_qc q_qc q_qN q_q5";
export var BodyNormal = "m_qd q_qd q_qN q_q6";
export var BodyLarge = "m_qf q_qf q_qN q_q7";